import { useSuspenseQueries } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PageLoadingFull } from "@workspace/venue-management";
import { eposApi } from "@workspace/venue-management-staff-terminal";
import { EposContextProvider } from "@workspace/venue-management-staff-terminal/epos";

export const Route = createFileRoute(
	"/_auth/_dashboard/$tenant/venues/$venueId/epos",
)({
	component: RouteComponent,
	pendingComponent: PageLoadingFull,
});

function RouteComponent() {
	const { tenant, venueId } = Route.useRouteContext();

	useSuspenseQueries({
		queries: [eposApi.getEposOptions(tenant, venueId)],
	});

	return (
		<EposContextProvider>
			<Outlet />
		</EposContextProvider>
	);
}
